import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Smartphone, Monitor, Printer, Zap } from 'lucide-react';
export function ProductPresentation() {
  return <section className="py-20 md:py-28 bg-sage/10" id="product" data-id="element-308">
      <div className="container mx-auto px-4" data-id="element-309">
        <div className="max-w-6xl mx-auto" data-id="element-310">
          <SectionWrapper data-id="element-311">
            <div className="text-center mb-12" data-id="element-312">
              <span className="inline-block px-4 py-1.5 rounded-full bg-sage/20 text-dark-green font-poppins text-sm font-bold tracking-widest uppercase mb-6" data-id="element-313">
                Presentamos
              </span>
              <h2 className="text-3xl md:text-5xl lg:text-6xl font-playfair font-bold text-dark-green mb-6 leading-tight" data-id="element-314">
                📚 MegaKit Plan de Calma
              </h2>
              <p className="text-xl md:text-2xl text-dark-green/80 font-poppins font-medium max-w-3xl mx-auto" data-id="element-315">
                El sistema completo de crianza en un combo de 6 ebooks PDF
              </p>
            </div>
          </SectionWrapper>

          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-316">
            <div className="w-full lg:w-1/2 order-2 lg:order-1" data-id="element-317">
              <SectionWrapper delay={0.2} data-id="element-318">
                <div className="bg-white p-8 md:p-10 rounded-3xl shadow-md border border-sage/20 mb-10" data-id="element-319">
                  <p className="text-dark-green/90 font-poppins text-lg md:text-xl leading-relaxed" data-id="element-320">
                    No es un libro de teoría. No es un curso con videos que
                    nunca terminás. Es un kit de 6 ebooks PDF diseñados como un
                    sistema completo y progresivo, donde cada tomo resuelve una
                    parte específica del problema.
                    <br data-id="element-321" />
                    <br data-id="element-322" />
                    Lo descargás hoy. Lo abrís en el celular, la tablet o la
                    computadora. Y podés empezar a aplicarlo desde el primer
                    berrinche de mañana.
                  </p>
                </div>

                <div className="flex flex-wrap justify-center lg:justify-start gap-x-6 gap-y-4 text-dark-green/90 font-poppins font-semibold text-sm md:text-base" data-id="element-323">
                  <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg shadow-sm border border-sage/10" data-id="element-324">
                    <Smartphone className="text-sage" size={20} data-id="element-325" /> En el celular
                  </div>
                  <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg shadow-sm border border-sage/10" data-id="element-326">
                    <Monitor className="text-sage" size={20} data-id="element-327" /> En la
                    computadora
                  </div>
                  <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg shadow-sm border border-sage/10" data-id="element-328">
                    <Printer className="text-sage" size={20} data-id="element-329" /> Imprimible
                  </div>
                  <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg shadow-sm border border-sage/10" data-id="element-330">
                    <Zap className="text-terracotta" size={20} data-id="element-331" /> Acceso en 5
                    minutos
                  </div>
                </div>
              </SectionWrapper>
            </div>

            <div className="w-full lg:w-1/2 order-1 lg:order-2" data-id="element-332">
              <SectionWrapper delay={0.4} data-id="element-333">
                <div className="relative" data-id="element-334">
                  <div className="absolute inset-0 bg-sage/20 blur-[80px] rounded-full -z-10" data-id="element-335"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/kSN8wy6AmABMGpBn8pFo1L/mockup_rabietas_2B_limites_con_amor.png" alt="MegaKit Plan de Calma" className="w-full h-auto drop-shadow-xl rounded-2xl" data-id="element-336" />
                </div>
              </SectionWrapper>
            </div>
          </div>
        </div>
      </div>
    </section>;
}